import React from "react";
import { useEffect, useState } from "react";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../scss/Scss/Home.scss";
import downarrow from "../scss/Icon/down_arrow.svg";
import Loading from "../AboutusPage/Loading.js";

function Homepage({ onNavigateToAbout }) {
  const [data, setData] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const docRef = doc(firestore, "CI WEB - SAFETY EDIT", "Home");
    const fetchData = async () => {
      try {
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot.exists()) {
          setData(docSnapshot.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();

    setIsMobile(window.innerWidth <= 1366);
    window.addEventListener("resize", () => {
      setIsMobile(window.innerWidth <= 1366);
    });

    return () => {
      window.removeEventListener("resize", () => {
        setIsMobile(window.innerWidth <= 1366);
      });
    };
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <>
        {!isLoading && data && (
          <div className="Home">
            <video
              loop
              muted
              autoPlay
              playsInline
              className={`Loadingvideo ${isMobile ? "LoadingvideoMB" : ""}`}
              style={{ pointerEvents: "auto" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <source src={data.CIWEBHOMEANIMATEDLOGO} type="video/mp4" />
            </video>
            {!isMobile ? (
              <div className="BgScrollDown" onClick={onNavigateToAbout}>
                <div className="TextScrollDown">SCROLL DOWN</div>
                <img
                  src={downarrow}
                  alt="scrolldown"
                  className="DownArrow"
                  loading="lazy"
                ></img>
              </div>
            ) : null}
          </div>
        )}
      </>
    </>
  );
}
export default Homepage;
